import { u as r, g as m, a as d, b as l } from "./ds-atom-stars-D9BF4aLK.js";
import { _ as f, v as g } from "./ds-atom-stars-D9BF4aLK.js";
import { storeToRefs as h } from "pinia";
import { d as M } from "./ds-molecule-accordion-item-CQ4ZVBCd.js";
const u = async (e, s = "en") => {
  const t = r(), { countryCode: a, countryMaskFile: o, countryValidatorFile: i, language: c } = h(t);
  a.value = e, o.value = new (await m(e))(), i.value = new (await d(e))(), c.value = s;
}, v = () => {
  const e = l(), { setDevice: s } = e, t = window.matchMedia("(max-width: 767px)"), a = window.matchMedia("(min-width: 768px) and (max-width: 1024px)"), o = window.matchMedia("(min-width: 1024px)"), i = t.matches ? "mobile" : a.matches ? "tablet" : o.matches ? "desktop" : "";
  s(i), [t, a, o].forEach((c) => {
    c.addEventListener("change", () => {
      const n = t.matches ? "mobile" : a.matches ? "tablet" : o.matches ? "desktop" : "";
      s(n);
    });
  });
};
export {
  f as DsAtomStars,
  M as DsMoleculeAccordionItem,
  u as setupDesignSystemComponentLibrary,
  l as useUserStore,
  g as validateValue,
  v as watchDeviceType
};
//# sourceMappingURL=main.es.js.map
